import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { add } from 'date-fns';

import { Button, MenuItem, Select, Stack } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

import { StatsMetric } from '../../../core/src/shared/enums';

import { jsDateToIsoDate } from '../utils/isodate';

import { trpc } from '../api/trpc';
import { ControlBox } from '../atoms/control-box';
import { useSelector } from '../store/utils';

const defaultFrom = add(new Date(), { months: -1 });
const defaultTo = new Date();

export const StatsExport = () => {
  const deviceId = useSelector(({ variables }) => variables.DEVICE_ID);

  const [metric, setMetric] = useState<StatsMetric>(StatsMetric.PV_POWER_GRAPH);
  const [from, setFrom] = useState<Date | null>(defaultFrom);
  const [to, setTo] = useState<Date | null>(defaultTo);

  const exportStats = trpc.exportStats.useMutation();

  const handleSubmit = () => {
    exportStats
      .mutateAsync({
        metric,
        from: from ? jsDateToIsoDate(from) : undefined,
        to: to ? jsDateToIsoDate(to) : undefined,
      })
      .then(
        (data) => {
          const generateCSV = () => {
            if (data.length === 0) return '';

            const headers = Object.keys(data[0]);
            const rows = data.map((item) => Object.values(item));

            const csvContent =
              headers.join(',') +
              '\n' +
              rows.map((row) => row.join(',')).join('\n');

            return csvContent;
          };

          const csvContent = generateCSV();

          const blob = new Blob([csvContent], {
            type: 'text/csv;charset=utf-8;',
          });
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);
          link.href = url;
          link.setAttribute('download', `${deviceId}-${metric}.csv`);
          link.click();
        },
        () => {
          alert('Při exportu došlo k chybě');
        }
      );
  };

  return (
    <ControlBox
      title={
        <FormattedMessage
          id="stats_export.title"
          defaultMessage="Exportovat statistiky"
        />
      }
      fullWidth
      control={
        <Stack direction="row" gap={1}>
          <Select
            label={
              <FormattedMessage
                id="stats_export.metric"
                defaultMessage="Metrika"
              />
            }
            value={metric}
            onChange={(e) => setMetric(e.target.value as StatsMetric)}
          >
            {Object.values(StatsMetric).map((item) => {
              return (
                <MenuItem value={item} key={item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>

          <DatePicker
            label={
              <FormattedMessage id="stats_export.from" defaultMessage="Od" />
            }
            // eslint-disable-next-line
            // @ts-ignore
            value={from}
            onChange={(value) => setFrom(value)}
            slotProps={{ field: { clearable: true } }}
          />

          <DatePicker
            label={
              <FormattedMessage id="stats_export.to" defaultMessage="Od" />
            }
            // eslint-disable-next-line
            // @ts-ignore
            value={to}
            onChange={(value) => setTo(value)}
            slotProps={{ field: { clearable: true } }}
          />

          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={exportStats.isLoading}
          >
            <FormattedMessage
              id="stats_export.button"
              defaultMessage="Export"
            />
          </Button>
        </Stack>
      }
    />
  );
};
